import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

const MyAccount = (props) => (
  <Svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#a)" fill="#5FAFFF">
      <Path d="M17.2 15.88h-2.4c-5.867 0-10.653 4.76-10.653 10.587v1.186h23.72v-1.186c0-5.827-4.8-10.587-10.654-10.587H17.2ZM16 15.213a5.44 5.44 0 1 0 0-10.88 5.44 5.44 0 0 0 0 10.88Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h32v32H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default MyAccount
